import { Range } from 'slate';

function isSelectionCollapsed(selection) {
  return selection !== null && Range.isCollapsed(selection);
}

export { isSelectionCollapsed };
//# sourceMappingURL=is-selection-collapsed.mjs.map
